import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import type { ConfigType } from 'dayjs';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * タイムゾーンを考慮した dayjs インスタンスを取得する
 * @param timeZone 優先するタイムゾーン（IANA）。未指定時はブラウザローカル。
 * @param date 任意の日付。未指定の場合は現在時刻。
 */
export const getZonedDate = (timeZone?: string, date?: ConfigType) => {
    if (timeZone) {
        return dayjs(date).tz(timeZone);
    }
    return dayjs(date);
};

export type DayjsWithTZ = ReturnType<typeof getZonedDate>;

export default dayjs;
